export default __webpack_public_path__ + "static/bsi-mark-of-trust-a19885b668e62e7c0bbcacbad2bd0f6d.svg";